import { For, Show, createSignal } from 'solid-js';
import { NON_AI_PROJECTS, AI_PROJECTS, A11Y } from '../../../constants/app-constants';
import gif1 from '../../../../public/images/gif1.gif';
import gif2 from '../../../../public/images/gif2.gif';
import paintshopGif from '../../../../public/images/paintshop.gif';
import jottyGif from '../../../../public/images/jotty.gif';
import vectorMcpVideo from '../../../../public/images/vector-mcp.webm';
import codeAutoVideo from '../../../../public/images/code-automata.webm';
import {
  BandGrid,
  BandColumn,
  BandTitle,
  ProjectRow,
  ProjectToggle,
  ProjectName,
  ProjectMeta,
  ProjectBody,
  Bezel,
  BezelScreen,
  ProjectLinks,
} from './styled-field';

const MEDIA = {
  'brick-breaker': { src: gif1, kind: 'image' },
  't90-tank': { src: gif2, kind: 'image' },
  paintshop: { src: paintshopGif, kind: 'image' },
  jotty: { src: jottyGif, kind: 'image' },
  'vector-mcp': { src: vectorMcpVideo, kind: 'video' },
  'code-automata': { src: codeAutoVideo, kind: 'video' },
};

/**
 * @param {{ project: object, band: 'green' | 'amber' }} props
 */
const ProjectEntry = (props) => {
  const [open, setOpen] = createSignal(!!props.startOpen);
  const media = () => MEDIA[props.project.id];
  const prefersReduced =
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return (
    <ProjectRow band={props.band} data-testid={`project-${props.project.id}`}>
      <ProjectToggle
        type="button"
        aria-expanded={open()}
        data-testid={`project-toggle-${props.project.id}`}
        onClick={() => setOpen(!open())}
      >
        <ProjectName class="project-name" band={props.band}>
          {props.project.title}
        </ProjectName>
        <ProjectMeta>{open() ? '[-]' : '[+]'}</ProjectMeta>
      </ProjectToggle>
      <Show when={open()}>
        <ProjectBody>
          <p>{props.project.description}</p>
          <Show when={media()}>
            <Bezel band={props.band}>
              <BezelScreen live={open() || prefersReduced}>
                <Show
                  when={media().kind === 'video'}
                  fallback={
                    <img src={media().src} alt={A11Y.labels.gamePreview(props.project.title)} />
                  }
                >
                  <video
                    src={media().src}
                    autoplay={!prefersReduced}
                    loop
                    muted
                    playsinline
                    controls={prefersReduced}
                    aria-label={A11Y.labels.gamePreview(props.project.title)}
                  />
                </Show>
              </BezelScreen>
            </Bezel>
          </Show>
          <ProjectLinks band={props.band}>
            <Show when={props.project.url}>
              <a href={props.project.url} target="_blank" rel="noopener noreferrer">
                open
              </a>
            </Show>
            <Show when={props.project.githubUrl}>
              <a href={props.project.githubUrl} target="_blank" rel="noopener noreferrer">
                source
              </a>
            </Show>
          </ProjectLinks>
        </ProjectBody>
      </Show>
    </ProjectRow>
  );
};

/**
 * Dual-phosphor project listing.
 */
const ProjectIndex = () => {
  return (
    <BandGrid>
      <BandColumn band="green" data-testid="band-green">
        <BandTitle band="green">no ai / canvas</BandTitle>
        <For each={NON_AI_PROJECTS}>
          {(project, index) => (
            <ProjectEntry project={project} band="green" startOpen={index() < 2} />
          )}
        </For>
      </BandColumn>
      <BandColumn band="amber" data-testid="band-amber">
        <BandTitle band="amber">agent / tools</BandTitle>
        <For each={AI_PROJECTS}>
          {(project, index) => (
            <ProjectEntry project={project} band="amber" startOpen={index() < 2} />
          )}
        </For>
      </BandColumn>
    </BandGrid>
  );
};

export default ProjectIndex;
